import { useEffect, useState } from "react";
import { API_URL } from "../../shared/api";
import { useParams } from "react-router-dom";
import useBackupUser from "./useBackupUser";

export default function useBackupGame() {
  const user = useBackupUser();
  const [ game, setGame ] = useState(undefined);
  const { gameId } = useParams();

  useEffect(() => {
    if (!user || !user.id || !gameId) return;

    fetch(`${API_URL}/users/${user.id}/games`, { method: "GET" })
      .then(response => response.json())
      .then(games => games.find(g => g.id === gameId))
      .then(setGame)
      .catch(err => console.error("Error fetching user:", err));
  }, [user, user?.id, gameId]);

  return game;
}
